// extracted by mini-css-extract-plugin
module.exports = {"label":"_4f720283bf--label--b5HBE","silver":"_4f720283bf--silver--mRcgf","orange":"_4f720283bf--orange--eAj6G","gray":"_4f720283bf--gray--wvTDT"};